export const styles = {
	global: {
		'html, body': {
			fill: 'transparent',
			fontFamily: 'ui',
			fontWeight: 'normal',
			letterSpacing: 'ui',
			lineHeight: 'base',
			strokeWidth: 0,
		},
	},
};
